import { THEME_NAME } from "../common/environment";
import { logger } from "../common/logger";
import type { SiteConfig } from "../common/types/themeTypes";

import diplomisSiteConfig from "./diplomis";
import leverantSiteConfig from "./leverant";
import tineSiteConfig from "./tine";

logger.log("ui", "Theme selected: ", THEME_NAME);

const theme: SiteConfig = (() => {
   switch (THEME_NAME) {
      case "tine":
         return tineSiteConfig;
      case "diplomis":
         return diplomisSiteConfig;
      case "leverant":
         return leverantSiteConfig;
      default:
         throw new Error("No supported THEME_NAME provided in environment");
   }
})();

export default theme;
